"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @preferred
 */
var service_1 = require("../service");
var _ = require("lodash");
var UserPhoneNumbers;
(function (UserPhoneNumbers) {
    function create(phoneNumber, type, description, isPrimary) {
        var _this = this;
        if (description === void 0) { description = ""; }
        if (isPrimary === void 0) { isPrimary = false; }
        return new Promise(function (resolve, reject) {
            // Create our service instance
            //
            var service = new service_1.EVAService("CreateUserPhoneNumber");
            // Build the request data
            // The base class will add things like SessionID so to keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                ID: _this.data.ID,
                PhoneNumber: phoneNumber,
                Type: type,
                Description: description,
                IsPrimary: isPrimary
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    UserPhoneNumbers.create = create;
    function update(id, phoneNumber, type, description) {
        if (description === void 0) { description = ""; }
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("UpdateUserPhoneNumber");
            var requestData = {
                ID: id,
                PhoneNumber: phoneNumber,
                Type: type,
                Description: description
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    UserPhoneNumbers.update = update;
    function remove(id) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("DeleteUserPhoneNumber");
            var requestData = {
                ID: id
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    UserPhoneNumbers.remove = remove;
    function makePrimary(id) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("MakeUserPhoneNumberPrimary");
            var requestData = {
                ID: id
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    UserPhoneNumbers.makePrimary = makePrimary;
    function list(userId) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("GetUserPhoneNumbers");
            var requestData = {
                UserID: userId
            };
            // Perform the call and capture the resulting promise
            //
            service.call(requestData)
                .then(function (result) {
                resolve(_.get(result, "response"));
            })
                .catch(reject);
        });
    }
    UserPhoneNumbers.list = list;
})(UserPhoneNumbers = exports.UserPhoneNumbers || (exports.UserPhoneNumbers = {}));
